/**
 *
 * Footer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
// import styled from 'styled-components';
import kvbLogo from '../../images/kvb_logo.png';
import securityLogo from '../../images/trusted_and_secure.png';
import Img from '../Img';
import { getLogoAsPerTheme } from '../../utils/common';
import { getUrlParam } from '../../helpers/route';
import { THEME_MODE } from '../../containers/App/constants';
import { translate as t } from '../../utils/translator';
import style from './style.module.scss';

const handleHelpRedirect = theme => {
  let HELP_REDIRECT_URL = '';
  switch (theme) {
    case THEME_MODE[1]:
      HELP_REDIRECT_URL =
        'https://www.amazon.in/gp/help/customer/display.html?nodeId=GJ626ASQQ6PD2KZY';
      break;
    case THEME_MODE[2]:
    case THEME_MODE[3]:
    case THEME_MODE[4]:
      HELP_REDIRECT_URL = 'https://pl-olc.capitalfloat.com/Faq?e=0';
      break;
  }
  window.open(HELP_REDIRECT_URL, '_blank');
};

function Footer(props) {
  const lenderId = getUrlParam('lender_id', null);

  return props.display ? (
    <div className={`footer ${style.footer}`}>
      <div className={style.footerImages}>
        <Img
          className={style.securityLogo}
          src={securityLogo}
          alt="trusted and secure"
        />
        <div className={style.lendingPartner}>
          <div className={style.lendingPartnerText}>{t('kyc17', props.language)}</div>
          <div className={style.partnerLogo}>
            <Img
              className={style.cfLogo}
              src={getLogoAsPerTheme(props.theme.toLowerCase(), 'axio_logo.png')}
              alt="axio"
            />
            {
              (lenderId == 1) && 
              <Img className={style.kvbLogo} src={kvbLogo} alt="karur vysya bank" />
            }
          </div>
        </div>
      </div>
      <div
        className={`helpAndFaq ${style.helpAndFaq}`}
        onClick={() => {
          handleHelpRedirect(props.theme);
        }}
      >
        {t('kyc21', props.language)}
      </div>
    </div>
  ) : null;
}

Footer.propTypes = {
  display: PropTypes.bool.isRequired,
  theme: PropTypes.string,
};

const mapStateToProps = state => ({
  language: state.language.language
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(Footer);
